import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHold = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: .25,
			y: .25,
			width: 24.5,
			height: 24.5,
			rx: 2.75,
			fill: "white",
			stroke: "#94A3B8",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 7,
			width: 3,
			height: 11,
			rx: 1,
			fill: "#395566"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 14,
			y: 7,
			width: 3,
			height: 11,
			rx: 1,
			fill: "#395566"
		})
	]
});
export default SvgHold;
